module.exports = __webpack_public_path__ + "img/img-4.1274f241.png";